import React from 'react'
import type { ProductV2Detail, Lang } from './types'

interface ProductDescriptionV2Props {
  product: ProductV2Detail
  currentLang: Lang
}

/**
 * ProductDescriptionV2
 *
 * Below the hero/info split, full-width single-column long-form description
 * (Barista Map style: serif sub-heading, clean paragraphs, no boxes).
 * Includes flavour notes as a simple inline line if present.
 */
const ProductDescriptionV2: React.FC<ProductDescriptionV2Props> = ({ product, currentLang }) => {
  const isZh = currentLang === 'zh'
  const text = isZh ? product.description : (product.descriptionEn || product.description)
  const flavorNotes = product.flavorNotes || []

  if (!text && flavorNotes.length === 0) return null

  return (
    <div className="mt-12 border-t border-black/10 pt-10">
      <h2
        className="mb-8 text-[11px] uppercase text-black/50"
        style={{ letterSpacing: '0.3em', fontFamily: "'EB Garamond', serif" }}
      >
        {isZh ? '關於這支豆' : 'About this coffee'}
      </h2>

      {flavorNotes.length > 0 && (
        <p
          className="mb-8 text-base md:text-lg text-black/80"
          style={{
            fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
            fontStyle: 'italic',
            letterSpacing: '0.02em',
          }}
        >
          {isZh ? '風味筆記｜' : 'Tasting notes — '}
          {flavorNotes.join(isZh ? '、' : ', ')}
        </p>
      )}

      {text && (
        <div
          className="space-y-5 text-[15px] leading-[1.85] text-black/75 whitespace-pre-line"
          style={{ fontFamily: "'Noto Serif TC', 'Zen Kaku Gothic New', sans-serif" }}
        >
          {text.split('\n\n').map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
      )}
    </div>
  )
}

export default ProductDescriptionV2
